module.exports = __webpack_public_path__ + "img/12.31137b38.jpg";